module.exports = __webpack_public_path__ + "img/car-card2.27a8713d.webp";